import http from '../jslibs/axios/http';

//文章管理 文章列表
export const getArticleList = data => (http.get('/v1/cms/Article', data));

//文章管理 添加文章
export const addArticle = data => (http.post('/v1/cms/Article', data));

//文章管理 删除文章
export const deleteArticle = uuid => (http.delete(`/v1/cms/Article/${uuid}`));

//文章管理 编辑文章
export const editArticle = data => (http.put(`/v1/cms/Article/${data.id}`, data));

//文章管理 文章详情
export const getArticleDetail = uuid => (http.get(`/v1/cms/Article/${uuid}`));

//文章管理 文章分类列表
export const getArticleClassList = data => (http.get('/v1/cms/ArticleClass', data));

//文章管理 新增文章分类
export const addArticleClass = data => (http.post('/v1/cms/ArticleClass', data));

//文章管理 编辑文章分类
export const editArticleClass = data => (http.put(`/v1/cms/ArticleClass/${data.id}`, data));

//文章管理 删除文章分类
export const deleteArticleClass = uuid => (http.delete(`/v1/cms/ArticleClass/${uuid}`));